import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaitotrimkeshwarcab() {



const cardData = {
  keyword: " Mumbai to Trimbakeshwar Cab",

headingDescription:
  "Omshree Cab offers reliable and comfortable Mumbai to Trimbakeshwar cab services for devotees and travelers planning a spiritual journey to one of the most sacred pilgrimage destinations in Maharashtra. Trimbakeshwar is famous for the Trimbakeshwar Jyotirlinga Temple dedicated to Lord Shiva and is one of the twelve Jyotirlingas in India. Whether you are planning a one-day pilgrimage, a family spiritual trip, or a religious tour including Nashik and nearby temples, our cab service ensures a smooth and safe journey with experienced drivers and well-maintained vehicles. We provide flexible booking options including one-way rides, round-trip packages, and multi-day travel plans with transparent per-kilometer pricing. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With punctual pickups from anywhere in Mumbai, skilled chauffeurs familiar with highway routes, and 24/7 customer support, Omshree Cab is your trusted partner for Mumbai to Trimbakeshwar cab booking.",

topPlaces: [
  {
    title: "Trimbakeshwar Jyotirlinga Temple",
    description:
      "Trimbakeshwar Temple is the main spiritual attraction in the town and one of the twelve sacred Jyotirlinga temples dedicated to Lord Shiva in India. Located at the foothills of the Brahmagiri mountains, the temple is known for its unique architecture built from black stone and its spiritual significance in Hindu traditions. The temple houses a special Shiva lingam representing the trinity of Brahma, Vishnu, and Mahesh. Devotees visit throughout the year to perform rituals such as Narayan Nagbali, Kalsarp Dosh Puja, and Rudrabhishek. Traveling by cab from Mumbai allows pilgrims to comfortably reach the temple and spend sufficient time participating in religious ceremonies and darshan."
  },
  {
    title: "Brahmagiri Hill",
    description:
      "Brahmagiri Hill is a sacred mountain located behind the Trimbakeshwar Temple and is believed to be the origin of the holy Godavari River. Devotees and trekking enthusiasts often climb the hill via a series of stone steps to reach ancient temples and scenic viewpoints. The hill offers panoramic views of the surrounding landscape and holds great mythological significance in Hindu scriptures. A comfortable cab journey from Mumbai allows travelers to reach Trimbakeshwar easily and explore Brahmagiri Hill as part of their spiritual and nature experience."
  },
  {
    title: "Kushavarta Kund",
    description:
      "Kushavarta Kund is a sacred water tank located near the Trimbakeshwar Temple and is considered the symbolic origin point of the Godavari River. Devotees take holy dips in the kund before visiting the temple, believing it purifies the soul and prepares them for worship. The site is also an important location during the Kumbh Mela celebrations held in Nashik and Trimbakeshwar. Traveling by cab provides convenient access to this holy site and allows pilgrims to comfortably include it in their temple visit."
  },
  {
    title: "Gangadwar",
    description:
      "Gangadwar is a sacred cave located on Brahmagiri Hill where the Godavari River is believed to originate before flowing down to the plains. The site is surrounded by natural beauty and holds deep spiritual importance for devotees visiting Trimbakeshwar. Pilgrims often trek to this location while exploring the hill and nearby temples. A cab trip from Mumbai ensures a comfortable journey to Trimbakeshwar so visitors can explore both the temple and surrounding sacred sites at a relaxed pace."
  },
  {
    title: "Anjaneri Hills",
    description:
      "Anjaneri Hills, located near Trimbakeshwar, are believed to be the birthplace of Lord Hanuman according to Hindu mythology. The hills are also a popular trekking destination offering beautiful landscapes, temples, and panoramic views of the Sahyadri mountain range. Visitors enjoy nature walks, trekking adventures, and spiritual exploration at this historic site. Traveling by cab makes it easy to include Anjaneri Hills in your Trimbakeshwar trip while enjoying a comfortable journey from Mumbai."
  },
  {
    title: "Pandavleni Caves",
    description:
      "Pandavleni Caves, also known as Nashik Caves, are ancient rock-cut caves located near Nashik and date back to around the 1st century BCE. These caves were used by Buddhist monks and feature inscriptions, sculptures, and meditation chambers carved into the hillside. Visitors interested in history and archaeology often explore this fascinating heritage site. A cab service from Mumbai to Trimbakeshwar allows travelers to conveniently include these caves in their itinerary while visiting the region."
  },
  {
    title: "Someshwar Waterfall",
    description:
      "Someshwar Waterfall is a picturesque waterfall located near Nashik and is a popular spot for nature lovers and photographers. The waterfall flows over rocky terrain and is especially beautiful during the monsoon season when the water volume increases significantly. Visitors enjoy the peaceful atmosphere, scenic surroundings, and nearby temple visits. Traveling by cab allows tourists to comfortably reach this natural attraction while exploring Trimbakeshwar and Nashik."
  },
  {
    title: "Sula Vineyards",
    description:
      "Sula Vineyards near Nashik is one of India’s most famous wine destinations and attracts tourists for wine tasting tours, vineyard walks, and scenic countryside views. Visitors can explore the wine production process, enjoy gourmet food, and relax amidst beautiful grape plantations. Many travelers visiting Trimbakeshwar combine their spiritual journey with a relaxing stop at Sula Vineyards. Booking a cab from Mumbai makes it convenient to visit both religious and leisure attractions in the region."
  },
  {
    title: "Ramkund Nashik",
    description:
      "Ramkund is a sacred bathing ghat on the banks of the Godavari River in Nashik and holds great significance in Hindu mythology. According to legend, Lord Rama performed rituals for his father here during his exile. Devotees gather to take holy dips and perform ancestral rites. Traveling by cab allows visitors to comfortably include Ramkund and other Nashik temples as part of their pilgrimage trip from Mumbai."
  },
  {
    title: "Muktidham Temple",
    description:
      "Muktidham Temple in Nashik is a beautiful marble temple complex that houses replicas of all twelve Jyotirlinga shrines of Lord Shiva. The temple also features inscriptions from the Bhagavad Gita carved on its walls. Pilgrims visiting Trimbakeshwar often visit Muktidham to complete their spiritual journey. A cab journey from Mumbai provides the flexibility to visit both Trimbakeshwar and Nashik temples comfortably in one trip."
  }
],



services: [
{
name: "Mumbai to Trimbakeshwar Cab",
description: "Mumbai to Trimbakeshwar cab service provides comfortable transportation for devotees visiting the sacred Trimbakeshwar Jyotirlinga temple located near Nashik. The temple is one of the twelve Jyotirlingas of Lord Shiva and attracts thousands of pilgrims every year. Our cab service offers clean and well-maintained vehicles suitable for long-distance highway travel. Professional drivers ensure safe driving and timely pickup from homes, hotels, offices, railway stations, and airport terminals across Mumbai. Spacious seating ensures comfortable journeys for families and groups traveling together. Ideal for pilgrimage travel, temple darshan, and religious tours. Flexible booking options allow convenient travel planning for devotees."
},
{
name: "Mumbai to Trimbakeshwar Taxi",
description: "Mumbai to Trimbakeshwar taxi service offers reliable transportation for devotees traveling to the holy Trimbakeshwar temple in Nashik district. The journey from Mumbai passes through scenic highways and offers a comfortable road trip for pilgrims and families. Vehicles are well maintained and provide smooth ride quality for long-distance journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup is available from homes, hotels, offices, railway stations, and airport terminals. Ideal for temple visits, religious tours, and family pilgrimages. Air-conditioned vehicles ensure comfortable journeys throughout the trip."
},
{
name: "Trimbakeshwar Jyotirlinga Cab Mumbai",
description: "Trimbakeshwar Jyotirlinga cab from Mumbai provides convenient transportation for devotees visiting one of the most sacred Jyotirlinga temples in India. The temple holds great religious significance and attracts pilgrims throughout the year. Our cab service ensures comfortable travel with spacious seating and smooth highway performance. Professional drivers provide safe driving and punctual pickup services from homes, hotels, offices, railway stations, and airport terminals across Mumbai. Ideal for family pilgrimages and religious tours. Comfortable vehicles ensure relaxed journeys for devotees traveling long distances."
},
{
name: "Mumbai to Trimbakeshwar Cab Service",
description: "Mumbai to Trimbakeshwar cab service offers dependable transportation for devotees planning temple visits and religious travel. Vehicles used for temple travel are suitable for long-distance highway journeys and provide comfortable seating for passengers. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for pilgrimage tours, temple visits, and spiritual travel. Air-conditioned vehicles ensure comfortable journeys for families and groups. Flexible booking options allow easy cab reservations."
},
{
name: "Mumbai to Trimbakeshwar Taxi Service",
description: "Mumbai to Trimbakeshwar taxi service provides convenient travel options for devotees visiting the famous Trimbakeshwar temple near Nashik. Vehicles provide smooth highway performance and spacious seating suitable for long-distance journeys. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for religious tours, pilgrimage travel, and family temple visits. Air-conditioned vehicles ensure relaxed travel throughout the journey. Flexible taxi booking options allow passengers to easily schedule their rides."
},
{
name: "Cab from Mumbai to Trimbakeshwar",
description: "Cab from Mumbai to Trimbakeshwar offers comfortable transportation for devotees visiting the sacred Jyotirlinga temple. Vehicles are suitable for highway travel and provide comfortable seating and luggage space for passengers. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for temple visits, pilgrimage travel, and family religious tours. Spacious vehicles ensure comfortable journeys throughout the trip. Flexible booking options allow convenient ride scheduling."
},
{
name: "Taxi from Mumbai to Trimbakeshwar",
description: "Taxi from Mumbai to Trimbakeshwar provides reliable transportation for devotees planning temple darshan and religious travel. Vehicles are designed for highway journeys and provide comfortable seating suitable for long-distance travel. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for pilgrimage tours and family temple visits. Air-conditioned vehicles ensure comfortable journeys throughout the trip. Flexible taxi booking options allow easy ride reservations."
},
{
name: "Mumbai to Trimbakeshwar Cab Booking",
description: "Mumbai to Trimbakeshwar cab booking allows devotees to easily reserve vehicles for temple visits and religious travel. Online and phone booking options provide quick confirmation and convenient ride scheduling. Vehicles used for temple travel provide comfortable seating and smooth ride quality for long-distance journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for pilgrimage travel, temple tours, and family religious journeys."
},
{
name: "Mumbai to Trimbakeshwar Taxi Booking Online",
description: "Mumbai to Trimbakeshwar taxi booking online provides convenient digital reservations for devotees planning temple visits. Travelers can easily schedule pickups and receive instant booking confirmation for their journey. Vehicles provide comfortable seating and smooth highway performance suitable for long-distance travel. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for families and devotees visiting the Jyotirlinga temple."
},
{
name: "Mumbai to Trimbakeshwar Cab Price",
description: "Mumbai to Trimbakeshwar cab price options provide transparent fare estimates for devotees planning temple travel. Pricing depends on vehicle category, travel distance, and trip duration. Travelers can choose sedan, SUV, or MPV vehicles based on comfort preferences and group size. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for pilgrimage travel and family temple visits. Comfortable vehicles ensure relaxed journeys."
},
{
name: "Mumbai to Trimbakeshwar Taxi Fare",
description: "Mumbai to Trimbakeshwar taxi fare services offer flexible pricing options depending on vehicle type and travel duration. Travelers can choose economical sedans or spacious SUVs depending on comfort needs. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for temple visits, pilgrimage tours, and family travel. Comfortable vehicles ensure relaxed journeys throughout the trip."
},
{
name: "Mumbai to Trimbakeshwar One Way Cab",
description: "Mumbai to Trimbakeshwar one way cab service offers economical intercity travel without return charges. Vehicles provide comfortable seating and smooth highway performance suitable for long-distance journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for devotees traveling one way for temple visits. Air-conditioned vehicles ensure comfortable journeys for pilgrims."
},
{
name: "Mumbai to Trimbakeshwar Round Trip Taxi",
description: "Mumbai to Trimbakeshwar round trip taxi service provides convenient transportation for devotees planning return travel after temple darshan. Vehicles are suitable for long-distance highway travel and same-day or multi-day trips. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for pilgrimage travel and family temple visits. Comfortable interiors ensure relaxed journeys."
},
{
name: "Mumbai to Trimbakeshwar Innova Cab",
description: "Mumbai to Trimbakeshwar Innova cab service provides spacious MPV transportation ideal for families and group pilgrimage travel. The Toyota Innova offers comfortable seating, smooth highway performance, and ample luggage space for temple journeys. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for family trips and religious tours."
},
{
name: "Jyotirlinga Darshan Cab Mumbai",
description: "Jyotirlinga darshan cab service from Mumbai offers comfortable transportation for devotees visiting sacred Jyotirlinga temples like Trimbakeshwar. Vehicles used for religious tours provide spacious seating and smooth highway performance suitable for long-distance travel. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for pilgrimage tours, temple visits, and spiritual travel across Maharashtra."
}
],

tableData: [
["Mumbai to Trimbakeshwar Cab","Mumbai to Trimbakeshwar Taxi"],
["Trimbakeshwar Jyotirlinga Cab Mumbai","Mumbai to Trimbakeshwar Cab Service"],
["Mumbai to Trimbakeshwar Taxi Service","Cab from Mumbai to Trimbakeshwar"],
["Taxi from Mumbai to Trimbakeshwar","Mumbai to Trimbakeshwar Cab Booking"],
["Mumbai to Trimbakeshwar Taxi Booking Online","Mumbai to Trimbakeshwar Cab Price"],
["Mumbai to Trimbakeshwar Taxi Fare","Mumbai to Trimbakeshwar One Way Cab"],
["Mumbai to Trimbakeshwar Round Trip Taxi","Mumbai to Trimbakeshwar Innova Cab"],
["Jyotirlinga Darshan Cab Mumbai","Temple Tour Cab Mumbai"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Temple Route Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in driving from Mumbai to Trimbakeshwar Temple near Nashik. They are familiar with the highway routes and local temple roads, ensuring a smooth and safe pilgrimage journey."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Omshree Cabs provides transparent pricing for Mumbai to Trimbakeshwar cab bookings. Customers receive clear information about per-kilometer fares, toll charges, and driver allowance before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Service",
    WhyChoosedescription: "Our Mumbai to Trimbakeshwar cab service operates 24 hours a day. Whether you want to start early morning for temple darshan or travel overnight, we provide reliable cab booking anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in our fleet are well maintained, regularly cleaned, and fully air-conditioned to ensure passengers enjoy a comfortable long-distance journey."
  },
  {
    WhyChooseheading: "Flexible One-Way & Round Trip Packages",
    WhyChoosedescription: "We offer flexible travel options including one-way cab booking, round trips, and same-day return packages from Mumbai to Trimbakeshwar temple."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers various vehicles including sedan cars, SUVs like Ertiga and Innova, luxury vehicles like Innova Crysta, and Tempo Travellers suitable for families and group pilgrims."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and airports anywhere in Mumbai so your Trimbakeshwar pilgrimage begins smoothly."
  },
  {
    WhyChooseheading: "Trusted Pilgrimage Cab Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many devotees traveling from Mumbai to Trimbakeshwar Jyotirlinga. Our punctual drivers, comfortable vehicles, and professional service ensure a peaceful spiritual journey."
  }
]
};

const faqData = [
  { question: "Do you provide cab service from Mumbai to Trimbakeshwar?", answer: "Yes, Omshree Cabs provides reliable cab services from Mumbai to Trimbakeshwar Temple for both one-way and round-trip travel." },
  { question: "What is the distance from Mumbai to Trimbakeshwar?", answer: "The distance from Mumbai to Trimbakeshwar is approximately 180 km and the journey usually takes around 4 to 5 hours depending on traffic and road conditions." },
  { question: "Can I combine Nashik and Trimbakeshwar in one trip?", answer: "Yes, many travelers combine Nashik sightseeing and Trimbakeshwar temple darshan in a single trip." },
  { question: "Which vehicles are available for the trip?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers depending on group size." },
  { question: "Is the cab service available 24 hours?", answer: "Yes, our Mumbai to Trimbakeshwar cab service operates 24/7 for passenger convenience." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Can we stop during the journey?", answer: "Yes, passengers can request stops during the journey for meals, rest, or sightseeing." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and festival seasons when many devotees visit Trimbakeshwar." },
  { question: "Do you provide pickup from Mumbai Airport?", answer: "Yes, we provide pickup from Mumbai Airport for travelers heading to Trimbakeshwar." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Ajay Kulkarni",
    feedback:
      "We booked Omshree Cabs for our Mumbai to Trimbakeshwar pilgrimage. The driver was very professional and the journey was smooth.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Patil",
    feedback:
      "Excellent cab service for temple travel. Comfortable vehicle and punctual driver made our Trimbakeshwar trip very peaceful.",
    rating: 5
  }
];











































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Trimbakeshwar Cab",
  "description": "Omshree Cab provides reliable cab services from Mumbai to Trimbakeshwar for Jyotirlinga darshan, one-way trips, and round trips. Travel comfortably with Innova and other well-maintained vehicles. Enjoy safe, punctual, and convenient journeys with flexible booking options and transparent pricing for family and religious tours.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "890"
  }
};







  return (
    <div>
      
<Helmet>
  <title>Mumbai to Trimbakeshwar Cab | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Omshree Cab offers cab services from Mumbai to Trimbakeshwar for Jyotirlinga darshan, one-way trips, and round trips. Travel with Innova and other vehicles. Safe, punctual, and convenient journeys with flexible booking options." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/67.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitotrimkeshwarcab;